import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ViewChild,
} from "@angular/core";
import { fromEvent } from "rxjs";

import { ConfigureService } from "../../../configure/configure.service";
import { IGoogleMapsStatic } from "./google-maps-static.interface";

@Component({
    selector: "mlp-google-maps-static",
    templateUrl: "./google-maps-static.component.html",
})
export class GoogleMapsStaticComponent implements OnInit {
    url = "";
    @ViewChild("mapContainer") elContainer: ElementRef;
    @ViewChild("mapImg") el: ElementRef;
    private _config: IGoogleMapsStatic = undefined;
    @Input()
    set config(config: IGoogleMapsStatic) {
        if (config) {
            this._config = config;
            this.generateStaticMapUrl(true);
        }
    }
    get config(): IGoogleMapsStatic {
        return this._config;
    }

    constructor(
        private configService: ConfigureService,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        // get new static map if window is resized
        fromEvent(window, "resize").subscribe((_) => {
            this.generateStaticMapUrl(true);
        });
    }

    generateStaticMapUrl(changeMapSize: boolean): void {
        if (this.config) {
            const containerStyles = getComputedStyle(
                this.elContainer.nativeElement
            );
            let mapWidth;
            let mapHeight;
            if (this.config.size) {
                const mapSizeArr = this.config.size.split("x");
                // changing map width to be container's width so map will be request with the right proportion
                // changeMapSize equals false for unit testing purpose as we're unable to check styles width
                mapWidth = changeMapSize
                    ? containerStyles.width.replace("px", "")
                    : mapSizeArr[0];
                mapHeight = mapSizeArr[1];
            }
            // forcing map/image to have the height set by the config object otherwise will change due to proportion
            this.renderer.setStyle(
                this.el.nativeElement,
                "height",
                `${mapHeight}px`
            );
            // optional parameters zoom and markerColor
            const zoom = this.config.zoom ? `zoom=${this.config.zoom}&` : "";
            const markerColor = this.config.markerColor
                ? `color:${this.config.markerColor}|`
                : "";
            // setting size depending on mapWidth and mapHeight
            const size = `${Math.round(mapWidth)}x${mapHeight}`;
            // tslint:disable-next-line:max-line-length
            this.url = `${this.configService.params.googleMapsDomain}/maps/api/staticmap?${zoom}size=${size}&markers=${markerColor}${this.config.latitude},${this.config.longitute}&key=${this.configService.params.googleMapsAPIkey}`;
        }
    }
}
